import {Injectable} from '@angular/core';
import {Http, Response, RequestOptions, Headers} from '@angular/http';
import {Observable} from 'rxjs';
import {User} from '../models/user.model';
import {environment} from '../../environments/environment';
import {PageData} from '../models/page-data.model';
import {Router} from '@angular/router';
import {isUndefined} from 'util';
import {Model} from '../models/model';

@Injectable()
export class BaseService {
  protected baseEndPoint = `http://${window.location.hostname}:3000/api/v1`;
  public pageData: PageData = new PageData();

  public constructor(protected http: Http, protected router: Router) {
    this.mapResourceData = this.mapResourceData.bind(this);
    this.handleError = this.handleError.bind(this);
  }

  protected makeModel(data): Model {
    return data;
  }

  protected extractData(res: Response) {
    return res.text() ? res.json() : {};
  }

  protected mapErrors(errors: Array<any>) {
    const mapped_errors = {};

    errors.forEach((el) => {
      if (mapped_errors[el.param]) {
        mapped_errors[el.param].push(el);
      } else {
        mapped_errors[el.param] = [el];
      }
    });
    console.log(mapped_errors);
    return mapped_errors;
  }

  protected mapResourceData(json) {
    if (this.hasPager(json) || json.data) {
      this.pageData = new PageData(json.current_page, json.from, json.per_page, json.total, json.ended);
      return json.data.map(d => this.makeModel(d)) || {};
    }
    if (Array.isArray(json)) {
      return json.map(d => this.makeModel(d)) || {};
    }
    return this.makeModel(json);
  }

  protected handleError(errors: Response | any) {
    if (errors.status === 401) {
      User.logout();
    } else if (errors.status === 403) {
      this.router.navigate(User.defaultRedirectTo());
    } else if (errors.json) {
      return Observable.throw(errors.json());
    }
    return Observable.of(errors);
  }

  protected url(action: string, params = null): string {
    return this.baseEndPoint + '/' + action;
  }

  protected hasPager(json) {
    return !isUndefined(json.current_page) &&
      !isUndefined(json.from) &&
      !isUndefined(json.per_page) &&
      !isUndefined(json.total);
  }

  protected getRequestOptions(params?: any, sendContentType = true): RequestOptions {
    const headers = new Headers();
    if (sendContentType) {
      headers.append('Content-Type', 'application/json');
    }
    if (!User.guest()) {
      headers.append('Authorization', 'Bearer ' +
        User.getTokenFromLS());
    }
    return new RequestOptions({
      headers: headers,
      ...{params}
    });
  }
}



// WEBPACK FOOTER //
// /Users/dade/work/sportclubby/sportclubby.livestreaming.frontend/src/app/services/base.service.ts